import { Component, OnInit, ViewChild } from '@angular/core';
import { AuthService } from 'src/app/services/auth.service';
import { PerfilService } from '../../services/perfil.service';
import { AlertController, IonButton } from '@ionic/angular';

@Component({
  selector: 'app-contrasena',
  templateUrl: './contrasena.component.html',
  styleUrls: ['./contrasena.component.scss'],
})
export class ContrasenaComponent implements OnInit {

  private id:number;
  private auth_key:string;
  displayUserData:any;
  currentPassword: string='';
  newPassword: string='';
  confirmPasswod: string='';

  @ViewChild('updateBtn') upBtn: IonButton;

  constructor(
    private authService: AuthService,
    private perfilService: PerfilService,
    private alertCtrl: AlertController
  ) { }

  ngOnInit() {
    this.authService.userData$.subscribe((res: any) => {
      this.displayUserData = res;
      this.auth_key = this.displayUserData?.auth_key;
      this.id = this.displayUserData?.id;

      });
  }

  changePassword(){
    this.upBtn.disabled = true;
    if(this.newPassword != '' && this.currentPassword != '' && this.confirmPasswod != ''){
      if(this.newPassword == this.confirmPasswod){
        this.perfilService.changePassword(this.id,this.auth_key, this.currentPassword, this.newPassword).subscribe( (res:any) => {
          this.presentAlert(res.mensaje);
          if(res.result){
            this.currentPassword ='';
            this.newPassword ='';
            this.confirmPasswod ='';
          }

          this.upBtn.disabled = false;
          //this.upBtn.
        });
      }else{
        const msg = 'Contaseñas no coinciden';
        this.presentAlert(msg);
        this.upBtn.disabled = false;
      }
    }else{
      const msg = 'Faltan datos';
      this.presentAlert(msg);
      this.upBtn.disabled = false;
    }
  }

  async presentAlert(msg) {
    const alert = await this.alertCtrl.create({
      header: 'Alerta',
      message: msg,
      buttons: ['Aceptar']
    });
    await alert.present();
    const { role } = await alert.onDidDismiss(); 
  }   
}
